var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"icon":"","title":_vm.title},on:{"click":_vm.onClick}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-file-download-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }